import { gql } from '@apollo/client';

// Panel "Prometeo" — consultas de la EMPRESA cliente (contacto de RRHH).
//
// Ninguna recibe `organization_id`: el backend resuelve la organización desde el usuario
// autenticado, así que el front no puede pedir la de otra empresa aunque lo intente.
//
// PRIVACIDAD: lo que llega aquí son agregados anónimos (k-anonymity K=5, resuelta en el
// backend) y uso de la app. El bienestar de una persona concreta no se expone nunca.

export const MY_ORGANIZATION = gql`
  query myOrganization {
    myOrganization {
      id
      name
      contact_name
      contact_email
      is_active
      company_covered_percent
      benefits
      cover_url
      logo_url
      members_count
      plan_discounts {
        plan_id
        plan_name
        client_discount_percent
        is_active
      }
    }
  }
`;

export const MY_ORGANIZATION_MEMBERS = gql`
  query myOrganizationMembers($department_id: ID, $search: String) {
    myOrganizationMembers(department_id: $department_id, search: $search) {
      id
      full_name
      email
      membership_status
      organization_joined_at
      plan_id {
        id
        name
      }
      department {
        id
        name
      }
    }
  }
`;

export const MY_ORGANIZATION_DEPARTMENTS = gql`
  query myOrganizationDepartments {
    myOrganizationDepartments {
      id
      name
      is_active
      members_count
    }
  }
`;

export const MY_ORGANIZATION_WELLBEING = gql`
  query myOrganizationWellbeing($department_id: ID, $weeks: Int) {
    myOrganizationWellbeing(department_id: $department_id, weeks: $weeks) {
      score
      protected
      respondents
      members
      participation_percent
      dimensions {
        dimension
        score
        protected
      }
      trend {
        week_key
        score
        protected
        respondents
      }
    }
  }
`;

export const MY_ORGANIZATION_HEATMAP = gql`
  query myOrganizationHeatmap($weeks: Int) {
    myOrganizationHeatmap(weeks: $weeks) {
      department_id
      department_name
      members
      respondents
      participation_percent
      protected
      overall
      cells {
        dimension
        score
        protected
      }
    }
  }
`;

// Adopción por departamento. El tipo trae `people`, pero aquí NO se pide: la empresa mira
// cuánto se usa el beneficio, no quién lo usa.
export const MY_ORGANIZATION_USAGE = gql`
  query myOrganizationUsage($weeks: Int) {
    myOrganizationUsage(weeks: $weeks) {
      department_id
      department_name
      members
      active_members
      adoption_percent
      workouts
      minutes
      workouts_per_member
      avg_completion_percent
      weeks
    }
  }
`;

export const MY_ORGANIZATION_REPORTS = gql`
  query myOrganizationReports {
    myOrganizationReports {
      id
      trigger
      weeks
      week_key
      score
      members
      respondents
      participation_percent
      was_protected
      created_at
    }
  }
`;

export const MY_ORGANIZATION_REPORT_URL = gql`
  query myOrganizationReportUrl($weeks: Int) {
    myOrganizationReportUrl(weeks: $weeks)
  }
`;

export const MY_ORGANIZATION_PLAN_REQUESTS = gql`
  query myOrganizationPlanRequests {
    myOrganizationPlanRequests {
      id
      seats
      status
      note
      created_at
      plan {
        id
        name
      }
      requester {
        id
        full_name
      }
    }
  }
`;

// Catálogo para el selector de "solicitar plan". El descuento negociado no vive aquí:
// lo define el administrador al aprobar la solicitud.
export const ORG_CLIENT_AVAILABLE_PLANS = gql`
  query orgClientAvailablePlans {
    plans(first: 100, page: 1) {
      data {
        id
        name
        description
        is_subscribable
        subscription_interval
      }
    }
  }
`;

export const REQUEST_ORGANIZATION_PLAN = gql`
  mutation requestOrganizationPlan($plan_id: ID!, $seats: Int, $note: String) {
    requestOrganizationPlan(plan_id: $plan_id, seats: $seats, note: $note) {
      id
      seats
      status
      note
      created_at
      plan {
        id
        name
      }
      requester {
        id
        full_name
      }
    }
  }
`;
